module.exports = global["jQuery"] = require("-!/tmp/build_5df3f0aa/node_modules/expose-loader/index.js?$!./jquery.js");